import React, { useEffect, useState } from 'react';
import { animate, useReducedMotion } from 'framer-motion';

// Counts up to `value` when it appears or changes; jumps straight there for reduced-motion users.
const CountUp: React.FC<{ value: number }> = ({ value }) => {
    const reduceMotion = useReducedMotion();
    const [shown, setShown] = useState(reduceMotion ? value : 0);
    useEffect(() => {
        if (reduceMotion) { setShown(value); return; }
        const controls = animate(shown, value, { duration: 0.8, ease: [0.16, 1, 0.3, 1], onUpdate: v => setShown(Math.round(v)) });
        return () => controls.stop();
    }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
    return <>{shown.toLocaleString('en-IN')}</>;
};

export default CountUp;
